/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrightness = createReactComponent("brightness", "IconBrightness", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 3l0 18", key: "svg-1" }],
  ["path", { d: "M12 9l4.65 -4.65", key: "svg-2" }],
  ["path", { d: "M12 14.3l7.37 -7.37", key: "svg-3" }],
  ["path", { d: "M12 19.6l8.85 -8.85", key: "svg-4" }]
]);

export { IconBrightness as default };
//# sourceMappingURL=IconBrightness.js.map
